module.exports = __webpack_public_path__ + "img/bookshelf.f909004a.png";